"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChatReplySmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13,7 C13,6.44771525 12.5522847,6 12,6 L5,6 C4.44771525,6 4,6.44771525 4,7 L4,11 C4,11.5522847 4.44771525,12 5,12 L6,12 L6,13 L5,13 C3.8954305,13 3,12.1045695 3,11 L3,7 C3,5.8954305 3.8954305,5 5,5 L12,5 C13.1045695,5 14,5.8954305 14,7 L13,7 Z M14.2960457,12 L11.5,12 C10.1192881,12 9,13.1192881 9,14.5 L9,16 L8,16 L8,14.5 C8,12.5670034 9.56700338,11 11.5,11 L14.2928932,11 L13.1473948,9.84660979 C12.9544044,9.65228989 12.9554735,9.33831557 13.1497827,9.14531445 C13.3442949,8.95211166 13.6584257,8.95260256 13.8523332,9.14641233 L16.2071068,11.5 L13.8504178,13.8605382 C13.6586007,14.0526685 13.3473498,14.0529225 13.1552194,13.8611054 L13.1537261,13.8596081 C12.961046,13.66558 12.9605951,13.3525646 13.1527154,13.1579822 L14.2960457,12 Z" })));
};
ChatReplySmall.displayName = 'ChatReplySmall';
exports.default = ChatReplySmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChatReplySmall.js.map